<template>
	<JBox class="s-min-h-screen s-bg-gray-100 s-w-full s-pt-32 s-p-4">
		<JBox class="s-max-w-sm s-mx-auto">
			<JHeadline class="s-text-center s-text-lg s-font-medium s-leading-9 s-text-gray-900">
				{{ $t("auth.signInToAccount") }}
			</JHeadline>

			<JBox class="s-mt-8">
				<JBox class="s-bg-white s-py-8 s-px-4 s-shadow sm:s-rounded-lg sm:s-px-10">
					<form @submit.prevent="handleSubmit">
						<JBox class="">
							<JLabel for="email" class="s-block s-text-sm s-font-medium s-leading-5 s-text-gray-700">
								{{ $t("auth.email") }}
							</JLabel>
							<JBox class="s-mt-1 s-rounded-md s-shadow-sm">
								<JInputText
									id="email"
									type="email"
									v-model="email"
									required=""
									class="s-appearance-none s-block s-w-full s-px-3 s-py-2 s-border s-border-gray-300 s-rounded-md s-placeholder-gray-400 focus:s-outline-none focus:s-shadow-outline-indigo focus:s-border-indigo-300 s-transition s-duration-150 s-ease-in-out sm:s-text-sm sm:s-leading-5"
								/>
							</JBox>
						</JBox>

						<JBox class="s-mt-6">
							<JLabel for="password" class="s-block s-text-sm s-font-medium s-leading-5 s-text-gray-700">
								{{ $t("auth.password") }}
							</JLabel>
							<JBox class="s-mt-1 s-rounded-md s-shadow-sm">
								<JInputText
									id="password"
									type="password"
									v-model="password"
									required=""
									class="s-appearance-none s-block s-w-full s-px-3 s-py-2 s-border s-border-gray-300 s-rounded-md s-placeholder-gray-400 focus:s-outline-none focus:s-shadow-outline-indigo focus:s-border-indigo-300 s-transition s-duration-150 s-ease-in-out sm:s-text-sm sm:s-leading-5"
								/>
							</JBox>
							<JText class="s-flex s-text-red-600 s-text-sm s-pt-2" v-if="errors.message">{{ $t("auth.loginError") }}</JText>
						</JBox>

						<JBox class="s-mt-6">
							<span class="s-block s-w-full s-rounded-md s-shadow-sm">
								<JButton
									type="submit"
									class="s-w-full s-flex s-justify-center s-py-2 s-bg-indigo-600 s-px-4 s-border s-border-transparent s-text-sm s-font-medium s-rounded-md s-text-white hover:s-bg-indigo-500 focus:s-outline-none focus:s-border-indigo-700 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-duration-150 s-ease-in-out"
								>
									{{ $t("auth.signIn") }}
								</JButton>
							</span>
						</JBox>
					</form>
				</JBox>
			</JBox>
		</JBox>
	</JBox>
</template>

<script>
// MOCK: this whole thing should be deleted and replaced with normal auth eventually

export default {
	data() {
		return {
			email: "",
			password: "",
			errors: {}
		}
	},

	methods: {
		async handleSubmit() {
			let res
			try {
				res = await this.$store.dispatch("auth/signIn", {
					username: this.email,
					password: this.password
				})
			} catch (error) {
				this.errors = {}
				this.errors.message = "Error"
				res = false
			}
			if (res) this.$router.push({ name: "ViewDashboardHome" })
		}
	}
}
</script>
